const routes = [
  {
    path: '/',
    redirect: '/agentCluster/input/MARKETING_EVENT_CLUSTER/agent_cluster/marketing_event_cluster',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        redirect: '/'
      },
      {
        path: '/brandStandard',
        name: 'BrandStandard',
        component: () => import('@/views/brandStandard/index.vue'),
        meta: {
          title: '品牌规范',
          menuPath: 'BrandStandard',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/brandVoice/:id?',
        name: 'BrandVoice',
        component: () => import('@/views/brandVoice/index.vue'),
        meta: {
          title: '品牌之声',
          menuPath: 'BrandVoice',
          permission: {
            old: [],
            new: []
          },
          shrink: true,
          sliderMenu: true
        }
      },
      {
        path: '/agentCluster',
        name: 'AgentCluster',
        redirect:
          '/agentCluster/input/MARKETING_EVENT_CLUSTER/agent_cluster/marketing_event_cluster'
      },
      {
        path: '/agentCluster/activityList/:templateCode/:subCode/:clusterCode',
        name: 'AgentClusterActivityList',
        component: () => import('@/views/agentCluster/activityList.vue'),
        meta: {
          title: '项目活动',
          menuPath: 'AgentCluster',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/agentCluster/input/:templateCode/:subCode/:clusterCode',
        name: 'AgentClusterInput',
        component: () => import('@/views/agentCluster/input.vue'),
        meta: {
          title: '智能体集群输入',
          menuPath: 'AgentCluster',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/agentCluster/chat/:templateCode/:subCode/:clusterCode/:id',
        name: 'AgentClusterChat',
        component: () => import('@/views/agentCluster/chat.vue'),
        meta: {
          title: '智能体集群聊天',
          menuPath: 'AgentCluster',
          collapseMainMenu: true,
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/offerAgentPlaza/:agentType?/:code?/:templateId?/:id?/:subCode?',
        name: 'OfferAgentPlaza',
        component: () => import('@/views/offerAgentPlaza/index.vue'),
        meta: {
          title: 'Offer智能体广场',
          menuPath: 'WritingAgent',
          collapseMainMenu: true,
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/lobsterPlaza',
        name: 'LobsterPlaza',
        component: () => import('@/views/lobsterPlaza/index.vue'),
        meta: {
          title: '营销“龙虾”广场',
          menuPath: 'LobsterPlaza',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/writingAgent/:code?/:templateId?/:id?',
        name: 'aiAgent',
        component: () => import('@/views/aiAgent/index.vue'),
        meta: {
          title: '写作智能体 ',
          menuPath: 'WritingAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/designAgent/:code?/:templateId?/:id?',
        name: 'DesignAgent',
        component: () => import('@/views/designAgent/index.vue'),
        meta: {
          title: '设计智能体 ',
          menuPath: 'DesignAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/videoAgent/:code?/:subCode?/:templateId?/:id?',
        name: 'VideoAgent',
        component: () => import('@/views/videoAgent/index.vue'),
        meta: {
          title: '视频智能体',
          menuPath: 'VideoAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/knowledgeBase/index.vue'),
        meta: {
          title: '知识库',
          menuPath: 'Knowledge',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/aiDam',
        name: 'AiDAM',
        component: () => import('@/views/aiDAM/index.vue'),
        meta: {
          title: '素材库',
          menuPath: 'AiDAM',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/aiVideoGeneration/createProject/:templateId/:templateCode',
        name: 'aiVideoGenerationCreateProject',
        component: () => import('@/views/aiVideoGeneration/createProject.vue'),
        meta: {
          title: 'AI一键成片',
          permission: {
            old: [],
            new: []
          },
          shrink: true,
          sliderMenu: true
        }
      },
      {
        path: '/aiVideoGeneration/projectList/:templateId/:templateCode',
        name: 'aiVideoGenerationProjectList',
        component: () => import('@/views/aiVideoGeneration/projectList.vue'),
        meta: {
          title: 'AI一键成片',
          permission: {
            old: [],
            new: []
          },
          shrink: true,
          sliderMenu: true
        }
      },
      {
        path: '/aiVideoGeneration/favorites/:templateId/:templateCode',
        name: 'aiVideoGenerationFavorites',
        component: () => import('@/views/aiVideoGeneration/favorites.vue'),
        meta: {
          title: 'AI一键成片',
          permission: {
            old: [],
            new: []
          },
          shrink: true,
          sliderMenu: true
        }
      },
      {
        path: '/inspirationLibrary',
        name: 'InspirationLibrary',
        component: () => import('@/views/inspirationLibrary/index.vue'),
        meta: {
          title: '灵感库',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/copywritingModel',
        name: 'CopywritingModel',
        component: () => import('@/views/enterpriseModel/copywritingModel/index.vue'),
        meta: {
          title: '文案模型',
          menuPath: 'CopywritingModel',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/designPattern',
        name: 'DesignPattern',
        component: () => import('@/views/enterpriseModel/designPattern/index.vue'),
        meta: {
          title: '设计模型',
          menuPath: 'DesignPattern',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/videoModel',
        name: 'VideoModel',
        component: () => import('@/views/enterpriseModel/videoModel/index.vue'),
        meta: {
          title: '视频模型',
          menuPath: 'VideoModel',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/user/userSetting',
        name: 'UserSetting',
        component: () => import('@/views/user/user.vue'),
        meta: {
          title: '个人中心',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/download/index',
        name: 'UserDownload',
        component: () => import('@/views/download/index.vue'),
        meta: {
          title: '下载中心',
          menuPath: 'UserDownload',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/user/userSafe',
        name: 'UserSafe',
        component: () => import('@/views/user/user.vue'),
        meta: {
          title: '个人中心',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },

      {
        path: '/user/combo',
        name: 'combo',
        component: () => import('@/views/user/combo.vue'),
        meta: {
          title: '我的套餐',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/consumption',
        name: 'consumption',
        component: () => import('@/views/user/consumption.vue'),
        meta: {
          title: '消耗日志',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/purchasePlan',
        name: 'purchasePlan',
        component: () => import('@/views/user/purchasePlan.vue'),
        meta: {
          title: '套餐购买',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/checkIn',
        name: 'checkIn',
        component: () => import('@/views/user/checkIn.vue'),
        meta: {
          title: '每日签到',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/invitation',
        name: 'invitation',
        component: () => import('@/views/user/invitation.vue'),
        meta: {
          title: '邀请好友',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamPackage',
        name: 'teamPackage',
        component: () => import('@/views/team/teamPackage.vue'),
        meta: {
          title: '团队/企业套餐',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamConsumption',
        name: 'teamConsumption',
        component: () => import('@/views/team/teamConsumption.vue'),
        meta: {
          title: '团队/企业消耗日志',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamBuy',
        name: 'teamBuy',
        component: () => import('@/views/team/teamBuy.vue'),
        meta: {
          title: '团队/企业套餐购买',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/memberManagement',
        name: 'memberManagement',
        component: () => import('@/views/team/memberManagement.vue'),
        meta: {
          title: '成员管理',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/memberSetting',
        name: 'memberSetting',
        component: () => import('@/views/team/memberSetting.vue'),
        meta: {
          title: '团队设置',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      }
    ]
  },
  {
    path: '/editorPage/:code?/:externalRecordId?/:externalTitleId?/:externalToolCallId?/:externalResultId?',
    name: 'editorPage',
    component: () => import('@/views/editorPage/index.vue'),
    meta: {
      title: '编辑器',
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/modelTraining/:templateId?',
    name: 'modelTraining',
    component: () => import('@/views/designAgent/modelTraining.vue'),
    meta: {
      title: '训练模型',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/videoModelTraining/:templateId?',
    name: 'videoModelTraining',
    component: () => import('@/views/videoAgent/videoModelTraining.vue'),
    meta: {
      title: '视频智能体训练模型',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/aiAgentStyle/:id',
    name: 'aiAgentStyle',
    component: () => import('@/views/aiAgent/aiAgentStyle.vue'),
    meta: {
      title: '训练风格',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/aiAgentStyle/:id/:itemId',
    name: 'aiAgentStyleEdit',
    component: () => import('@/views/aiAgent/aiAgentStyle.vue'),
    meta: {
      title: '训练风格',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/detailPage/:Id/:type',
    name: 'DetailPage',
    component: () => import('@/views/detailPage/detailPage.vue'),
    meta: {
      title: '首页详情页',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/invitePage',
    name: 'InvitePage',
    component: () => import('@/views/team/invitePage.vue'),
    meta: {
      title: '团队/企业管理邀请页面',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/thread/:id',
    name: 'thread',
    component: () => import('@/views/aiTools/share.vue'),
    meta: {
      title: '会话分享页面',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
    meta: {
      title: '登录',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agreement/userAgreement',
    name: 'userAgreement',
    component: () => import('@/views/agreement/userAgreement/index.vue'),
    meta: {
      title: '使用协议',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agreement',
    name: 'privacyAgreement',
    component: () => import('@/views/agreement/privacyAgreement.vue'),
    meta: {
      title: '隐私保护协议',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/workFlow/scriptGeneration/:id/:executeCode',
    name: 'ScriptGeneration',
    component: () => import('@/views/intelligent/scriptGeneration.vue'),
    meta: {
      title: '编辑',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/workFlow/scriptRunning/:id/:executeCode',
    name: 'ScriptRunning',
    component: () => import('@/views/intelligent/scriptRunning.vue'),
    meta: {
      title: '运行',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/runLog/:id',
    name: 'RunLog',
    component: () => import('@/views/intelligent/runLog.vue'),
    meta: {
      title: '运行记录',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/runLog/scriptRunningResult/:id/:executeCode/:recordId/:executeType',
    name: 'ScriptRunningResult',
    component: () => import('@/views/intelligent/scriptRunning.vue'),
    meta: {
      title: '运行加查询结果',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/pdfDetail/:contentId',
    name: 'pdfDetail',
    component: () => import('@/views/aiBrain/pdfDetail.vue'),
    meta: {
      title: 'pdf详情',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/share/:code',
    name: 'shareFolder',
    component: () => import('@/views/aiDAM/share.vue'),
    meta: {
      title: '文件分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      },
      fixurl: (route) => {
        return process.env.VUE_APP_aiDAM_H5_URL + route.params.code
      }
    }
  },
  {
    path: '/underMaintenance',
    name: 'underMaintenance',
    component: () => import('@/views/pageStatus/underMaintenance.vue'),
    meta: {
      title: '维护升级',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/knowledgeShare/:code',
    name: 'knowledgeShareFolder',
    component: () => import('@/views/knowledgeBase/knowledgeShare.vue'),
    meta: {
      title: '文件分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      },
      fixurl: (route) => {
        return process.env.VUE_APP_knowledge_H5_URL + route.params.code
      }
    }
  },
  {
    path: '/aiVideoGenerationShare/:code',
    name: 'aiVideoGenerationShareFolder',
    component: () => import('@/views/aiVideoGeneration/aiVideoGenerationShare.vue'),
    meta: {
      title: '文件分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.code
      // }
    }
  },
  {
    path: '/aiAgentShare/:id',
    name: 'aiAgentShare',
    component: () => import('@/views/aiAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.id
      // }
    }
  },
  {
    path: '/designAgentShare/:id/:code?',
    name: 'designAgentShare',
    component: () => import('@/views/designAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/videoAgentShare/:id/:code?',
    name: 'videoAgentShare',
    component: () => import('@/views/videoAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agentClusterChatShare/:templateCode/:subCode/:clusterCode/:id',
    name: 'AgentClusterChatShare',
    component: () => import('@/views/agentCluster/share.vue'),
    meta: {
      title: '智能体集群聊天分享',
      menuPath: 'AgentCluster',
      permission: {
        old: [],
        new: []
      },
      shrink: true,
      sliderMenu: true
    }
  },
  {
    path: '/designAgentImageShare/:id',
    name: 'designAgentImageShare',
    component: () => import('@/views/designAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.id
      // }
    }
  },
  {
    path: '/designAgentMaterialShare/:id',
    name: 'designAgentMaterialShare',
    component: () => import('@/views/designAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.id
      // }
    }
  },
  {
    path: '/videoEditingAssistant/detail/:id',
    name: 'videoEditingDetail',
    component: () => import('@/views/videoEditingAssistant/detail.vue'),
    meta: {
      title: '视频混剪详情',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/aiVideoGeneration/generationList/:id/:templateId/:templateCode',
    name: 'generationList',
    component: () => import('@/views/aiVideoGeneration/generationList.vue'),
    meta: {
      title: 'AI一键成片生成列表页面',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/index/test.vue'),
    meta: {
      title: '测试页面',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/debuggingPrompt',
    name: 'DebuggingPrompt',
    component: () => import('@/views/index/debuggingPrompt.vue'),
    meta: {
      title: '调试提示词',
      hideFloatBtn: true
    }
  },
  {
    path: '/pageStatus/:code',
    name: 'pageStatus',
    component: () => import('@/views/status/index.vue'),
    meta: {
      title: '状态页面',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/pageStatus/notFound'
  }
]

export default routes
